// src/utils/defaultResponseHandler.ts
async function defaultResponseHandler(res) {
  const hasJsonContent = res.headers.get("content-type")?.includes("json") ?? false;
  if (hasJsonContent) {
    return await res.json();
  }
  return res;
}
export {
  defaultResponseHandler as default
};
